define([
    './defined',
    './defaultValue'
    ], function(
        defined,
        defaultValue
    ) {
    'use strict'

    /**
     * 将Vec3Obj对象数组转成一定规则的字符串，用于参数传递。
     *
     * @private
     *
     * @exports colorArray2String
     */
    const colorArray2String = (arr, sp1, sp2)=>{
        let splitStr1 = defaultValue(sp1, ",")
        let splitStr2 = defaultValue(sp2, ";")
        let result = ""
        for (let i = 0; i < arr.length; ++i) {
            result += arr[i].red + splitStr1 + arr[i].green + splitStr1 + arr[i].blue + splitStr1 + arr[i].alpha + splitStr2
        }
        return result
    }
    return colorArray2String
})
